<div class="package-grid-container">
    <app-package-grid-card *ngFor="let package of packages; trackBy: trackById" [package]="package" (edit)="editPackage($event)" (delete)="deletePackage($event)" (duplicate)="duplicatePackage($event)"></app-package-grid-card>
</div>
  
